export default __webpack_public_path__ + "static/media/file_00002 (2).68b02d52.pdf";